import React from 'react';

const Loading = ({ main }) => (
  <div className={`d-flex justify-content-center pt-5 ${main && 'mt-5'}`}>
    <div className='lds-dual-ring' />
  </div>
);

export default Loading;
